import React, { forwardRef, useMemo } from 'react';
import cn from 'classnames';
import { useScrollbarWidth } from '@platform-ui/dom-utils';
import { dataQa } from '@tui-react/core';
import styles from './Scroll.module.css';
export const ScrollContent = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    dataQaType = 'uikit/scroll',
    onScroll,
    onWheel,
    id,
    children,
    native = false,
    mounted = false,
    disabled = false,
    className,
    style
  } = props;
  const width = useScrollbarWidth();
  const contentClassName = useMemo(() => cn({
    [styles.content]: true,
    [styles.content_scrollbar_hidden]: !mounted || !native,
    [styles.content_scrollbar_disabled]: !mounted || disabled,
    [styles.content_scrollbar_native]: mounted && native,
    [styles.content_scrollbar_native_legacy]: mounted && native && width
  }, className), [mounted, native, disabled, width, className]);
  return /*#__PURE__*/React.createElement("div", Object.assign({}, dataQa({
    dataQaType: `${dataQaType}.content`
  }), {
    ref: ref,
    className: contentClassName,
    style: style,
    id: id,
    onScroll: onScroll,
    onWheel: onWheel
  }), children);
});